/**
 * Parses urgency level from the AI response text and renders a color-coded badge.
 * Supports new prompt keywords: GO NOW, BOOK APPOINTMENT, RELAX
 * as well as legacy: URGENT, SEE_DOCTOR
 */
export default function UrgencyBadge({ resultText, large }) {
  const upper = resultText ? resultText.toUpperCase() : '';

  let badge;

  if (upper.includes('GO NOW') || upper.includes('URGENT')) {
    badge = {
      label: '🔴 Go Now — seek care immediately',
      bg: '#fef2f2', color: '#991b1b', border: '1px solid #fca5a5',
    };
  } else if (
    upper.includes('BOOK APPOINTMENT') ||
    upper.includes('SEE_DOCTOR') ||
    upper.includes('SEE DOCTOR')
  ) {
    badge = {
      label: '🟡 Book Appointment — see a doctor soon',
      bg: '#fffbeb', color: '#92400e', border: '1px solid #fcd34d',
    };
  } else {
    badge = {
      label: '🟢 Relax — looking normal',
      bg: '#f0fdf4', color: '#166534', border: '1px solid #86efac',
    };
  }

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: large ? '8px 20px' : '6px 14px',
      borderRadius: 999,
      fontSize: large ? 14 : 13,
      fontWeight: 600,
      background: badge.bg,
      color: badge.color,
      border: badge.border,
      whiteSpace: 'nowrap',
    }}>
      {badge.label}
    </span>
  );
}
